import { createContext, useEffect, useReducer } from "react";

import axios from "../utils/axios";
import PasswordReducer from "../reducers/PasswordReducer";
import { isValidToken, setSession } from "../utils/jwt";
import { PasswordConstants } from "../constants/password.constants";
import { saveFile } from "../utils/common";
const initialState = {
  isLoading: true,
  passwords: [],
  paging: {
    totalNumberOfRecords: 0,
    totalNumberOfPages: 0,
    pageNumber: 0,
    pageSize: 0,
  },
  hasError: false,
  errorMessage: "",
  passwordSearchResults: [],
  generatedPassword: {},
  isUpload: false,
  uploadError: false,
  uploadSuccess: false,
  isSubmitting: false,
  isLoadingDownload: false,
  passwordAutoSearchResults: {
    data: [],
    paging: {
      hasNextPage: false,
      hasPreviousPage: false,
      pageNumber: 0,
      pageSize: 0,
      totalNumberOfPages: 0,
      totalNumberOfRecords: 0,
    },
  },
  autoSearchLoading: false,
  isLoading: true,
  downloadFileType: "",
  isLoadingAutoSearch: true,
};
const initPayload = {
  filters: [],
  pagination: {
    pageNumber: 1,
    pageSize: 100,
  },
  sortFields: [],
};

const PasswordContext = createContext({
  ...initialState,
  getAllPassword: () => {},
  addPassword: () => {},
  searchPassword: () => {},
  autoSearchPassword: () => {},
  getPassword: () => {},
  updatePassword: () => {},
  downloadFile: () => {},
  sampleFile: () => {},
  uploadFile: () => {},
});

function PasswordProvider({ children }) {
  const [state, dispatch] = useReducer(PasswordReducer, initialState);

  const getAllPassword = async (payload) => {
    try {
      dispatch({
        type: PasswordConstants.FETCH_PASSWORD_REQUEST,
      });
      const response = await axios.post("/master/password/list", payload);
      dispatch({
        type: PasswordConstants.FETCH_PASSWORD_SUCCESS,
        payload: response.data,
      });
      return response.data;
    } catch (exception) {
      dispatch({
        type: PasswordConstants.FETCH_PASSWORD_FAILURE,
      });
    }
  };
  const searchPassword = async (payload) => {
    try {
      const response = await axios.post("/master/password/search", payload);
      dispatch({
        type: PasswordConstants.PASSWORD_SEARCH_REQUEST,
      });
      console.log(response.data, "response.data");
      dispatch({
        type: PasswordConstants.PASSWORD_SEARCH_SUCCESS,
        payload: response.data,
      });
    } catch (exception) {
      dispatch({
        type: PasswordConstants.PASSWORD_SEARCH_FAILURE,
      });
    }
  };
  const autoSearchPassword = async (payload) => {
    try {
      const response = await axios.post("/master/password/auto-search", payload);
      dispatch({
        type: PasswordConstants.PASSWORD_AUTO_SEARCH_REQUEST,
      });
      console.log(response.data, "response.data");
      dispatch({
        type: PasswordConstants.PASSWORD_AUTO_SEARCH_SUCCESS,
        payload: response.data,
      });
    } catch (exception) {
      dispatch({
        type: PasswordConstants.PASSWORD_AUTO_SEARCH_FAILURE,
      });
    }
  };
  const addPassword = async (payload) => {
    const response = await axios.post("/master/password/add", payload);
    dispatch({
      type: PasswordConstants.ADD_PASSWORD_REQUEST,
    });
    dispatch({
      type: PasswordConstants.ADD_PASSWORD_SUCCESS,
      payload: response.data,
    });
  };

  // const getPassword = async () => {
  //   try {
  //     dispatch({ type: PasswordConstants.GET_PASSWORD_REQUEST });

  //     const response = await axios.get("/password/generate");
  //     const password = response.data.password;

  //     dispatch({
  //       type: PasswordConstants.GET_PASSWORD_SUCCESS,
  //       payload: password,
  //     });

  //     return password;
  //   } catch (error) {
  //     dispatch({
  //       type: PasswordConstants.GET_PASSWORD_FAILURE,
  //     });
  //     return null;
  //   }
  // };

  // const getPassword = async () => {
  //   try {
  //     dispatch({ type: PasswordConstants.GET_PASSWORD_REQUEST });

  //     const response = await axios.get("/password/generate");
  //     console.log("Password response:", response.data);
  //     const password = response.data.password;
  //     console.log("Extracted password:", password);

  //     console.log("FULL AXIOS RESPONSE", response);

  //     dispatch({
  //       type: PasswordConstants.GET_PASSWORD_SUCCESS,
  //       payload: password, // ✅ send only the string to reducer
  //     });

  //     return password; // ✅ return only the string
  //   } catch (error) {
  //     dispatch({ type: PasswordConstants.GET_PASSWORD_FAILURE });
  //     console.error("Password generation error:", error);
  //     return undefined;
  //   }
  // };

  const getPassword = async () => {
    const response = await axios.get("/password/generate");
    dispatch({
      type: PasswordConstants.GET_PASSWORD_REQUEST,
    });
    dispatch({
      type: PasswordConstants.GET_PASSWORD_SUCCESS,
      payload: response.data,
    });
    return response.data;
  };

  const updatePassword = async (payload) => {
    const response = await axios.put("/master/password/update/" + payload.passwordId, payload);
    dispatch({
      type: PasswordConstants.UPDATE_PASSWORD_REQUEST,
    });
    dispatch({
      type: PasswordConstants.UPDATE_PASSWORD_SUCCESS,
      payload: response.data,
    });
  };

  const downloadFile = async (fileType, payload) => {
    dispatch({
      type: PasswordConstants.DOWNLOAD_PASSWORD_REQUEST,
      payload: {
        fileType: fileType,
      },
    });
    const response = await axios.post("/master/password/export/" + fileType, payload, {
      responseType: "blob",
    });
    console.log(response.headers, "filename");
    //const filename = response.headers.get("content-disposition").split('"');

    await saveFile(response.data, "password." + fileType);
    dispatch({
      type: PasswordConstants.DOWNLOAD_PASSWORD_SUCCESS,
      payload: response.data,
    });
  };

  const sampleFile = async (fileType) => {
    const response = await axios.get("/master/password/sample/" + fileType, {
      responseType: "blob",
    });

    await saveFile(response.data, "sample_password." + fileType);
    dispatch({
      type: PasswordConstants.DOWNLOAD_PASSWORD_REQUEST,
    });
    dispatch({
      type: PasswordConstants.DOWNLOAD_PASSWORD_SUCCESS,
      payload: response.data,
    });
  };

  const uploadFile = async (payload) => {
    try {
      dispatch({
        type: PasswordConstants.UPLOAD_PASSWORD_REQUEST,
      });
      const response = await axios({
        url: "/master/password/upload",
        method: "POST",
        data: payload,
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      dispatch({
        type: PasswordConstants.UPLOAD_PASSWORD_SUCCESS,
        payload: response.data,
      });
    } catch (error) {
      console.log("errr", error);
      dispatch({
        type: PasswordConstants.UPLOAD_PASSWORD_FAILURE,
      });
    }
  };

  return (
    <PasswordContext.Provider
      value={{
        ...state,
        getAllPassword,
        addPassword,
        searchPassword,
        autoSearchPassword,
        getPassword,
        updatePassword,
        downloadFile,
        sampleFile,
        uploadFile,
      }}
    >
      {children}
    </PasswordContext.Provider>
  );
}

export { PasswordContext, PasswordProvider };
